import React from "react";
import _ from "lodash";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const useStyles = makeStyles({
  autoComplete: {
    color: "red",
  },
});

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: "121px",
        marginBottom: "0",

        "& fieldset": {
          border: 0,
        },
      },
    },
    MuiInput: {
      formControl: {
        marginTop: "0 !important",
      },
    },
    MuiOutlinedInput: {
      root: {
        paddingRight: "0 !important",

        "& $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "&:hover $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
      },
      input: {
        borderRadius: "6px",
        backgroundColor: "#E8E8E8 !important",
        color: "#333333",
        padding: "14px 0",
        fontSize: "16px",
        lineHeight: "19px",
      },
    },
  },
});

const TimePicker = ({ timeValue, setTimeValue }: any) => {
  const classes = useStyles();
  const dateUtils = new DateFnsUtils();

  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardTimePicker
          placeholder="HR : MIN"
          ampm={false}
          inputVariant="outlined"
          invalidDateMessage="Invalid Time"
          value={timeValue}
          mask="__:__"
          InputAdornmentProps={{
            style: { display: "none" },
          }}
          // InputProps={{
          //   disableUnderline: true
          // }}
          inputProps={{ style: { textAlign: "center", borderColor: "#ECECEC" } }}
          onChange={(date, value: any) => {
            setTimeValue(date);
          }}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

export default TimePicker;
